import * as React from 'react'

const SidePanelOverlayContext =
  React.createContext<React.RefObject<HTMLDivElement | null> | null>(null)

export const useSidePanelOverlayRoot = () =>
  React.useContext(SidePanelOverlayContext)

export const SidePanelOverlayProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const overlayRootRef = React.useRef<HTMLDivElement>(null)

  return (
    <SidePanelOverlayContext.Provider value={overlayRootRef}>
      {children}
      <div
        ref={overlayRootRef}
        className="tw:pointer-events-none tw:absolute tw:inset-0 tw:z-[200]"
      />
    </SidePanelOverlayContext.Provider>
  )
}
